import { 
  Scale, 
  BarChart3, 
  CheckCircle, 
  Circle, 
  MessageSquare, 
  List,
  Star,
  ThumbsUp,
  FileText,
  Hash
} from 'lucide-react';

// Icon mapping for question types
export const questionTypeIconMap: Record<string, any> = {
  'likert': Scale,
  'likert_scale': Scale,
  'rating': BarChart3,
  'rating_scale': BarChart3,
  'yes_no': CheckCircle,
  'boolean': CheckCircle,
  'multiple_choice': Circle,
  'open_ended': MessageSquare,
  'text': MessageSquare,
  'ranking': List,
  'scale': Star,
  'nps': ThumbsUp,
  'long_text': FileText,
  'number': Hash,
};

export function getQuestionTypeIcon(type: string) {
  // Normalize the type string to match our mapping
  const normalizedType = type.toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[()]/g, '')
    .replace(/\d+-\d+/g, 'scale')
    .replace(/1-\d+/g, 'scale');
  
  // Check exact matches first
  if (questionTypeIconMap[normalizedType]) {
    return questionTypeIconMap[normalizedType];
  }
  
  // Check partial matches
  for (const [key, icon] of Object.entries(questionTypeIconMap)) {
    if (normalizedType.includes(key) || key.includes(normalizedType)) {
      return icon;
    }
  }
  
  // Default fallback
  return Circle;
}